export default __webpack_public_path__ + "static/media/whyUS.6f5ff4b2.jpg";